import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import { LineHeader, Header } from './elements';
import { useText } from 'common/hooks';
import Event from 'challenge/common/Event';
import { Masonry } from 'dc/Masonry';

const deps = {
  profiles: state.appContainer.profiles,
  events: state.challenge.events.computedEvents,
  isLoadingEvents: state.challenge.isLoading.events,
};

export function EventTypes({
  events,
  isLoadingEvents,
}: typeof deps & ConnectedProps): React.ReactElement {
  if (isLoadingEvents) {
    return null;
  }
  const t = useText();

  const newEvents = () => {
    if (events?.newEvents?.length === 0) return null;

    return (
      <>
        <LineHeader>
          <Header>{t('challenge.latest_events.new')}</Header>
        </LineHeader>
        <Masonry
          options={{ gap: '32px' }}
          cards={events.newEvents.map(event => (
            <Event key={event.key} eventKey={event.key} />
          ))}
        />
      </>
    );
  };

  const oldEvents = () => {
    if (events?.oldEvents?.length === 0) return null;

    return (
      <>
        {events?.newEvents?.length !== 0 && (
          <LineHeader>
            <Header>{t('challenge.latest_events.earlier')}</Header>
          </LineHeader>
        )}
        <Masonry
          options={{ gap: '32px' }}
          cards={events.oldEvents.map(event => (
            <Event key={event.key} eventKey={event.key} />
          ))}
        />
      </>
    );
  };

  return (
    <>
      {newEvents()}
      {oldEvents()}
    </>
  );
}

export default connect(deps, EventTypes);
